<template>
  <div class="Contest">
    <div class="body">
      <div class="title htitle fs26">{{title}}</div>
      <div class="timer">还剩{{timer}}</div>
      <div class="problems">
        <selection v-for="(p, index) in problems" :problem="p" :pindex="index+1" :key="p.problem_id" :savedAnswer="answers[p.exam_problem_id]" ></selection>
      </div>
      <div>
        <my_button @click.native="submit" value="提交"></my_button>
      </div>
    </div>
    <modal name="confirm-submit">
      <div class="content">
        确定提交答卷？
      </div>
      <div class="buttons">
        <my_button :style="cancelStyle" @click.native="cancel" value="取消"></my_button>
        <my_button @click.native="confirm" value="提交"></my_button>
      </div>
    </modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Selection from '@/components/contest/selection';
import MyButton from '@/components/Button.vue'
import moment from 'moment'
export default {
  name: 'Contest',
  data () {
    return {
      rank: null,
      problems: [],
      now: new Date(),
      answers: {}
    }
  },
  mounted () {
    this.$http.get('/api/rank/me').then(res => {
      this.rank = res.data
      setInterval(() => {
        this.now = moment(+new Date() + this.$store.state.timeDelay)
      }, 1000)
    })
    this.$http.get('/api/exam_problems').then(res => {
      this.problems = res.data
    })
    this.$http.get('/api/submissions/me').then(res => {
      res.data.forEach(p => {
        this.answers[p.exam_problem_id] = p.answer.map(a => parseInt(a))
      })
    })
  },
  computed: {
    title() {
      return '初赛'
    },
    cancelStyle () {
      return {
        'background': 'white',
        'color': '#141413',
        'border': '1px solid #141413'
      }
    },
    timer () {
      if (!this.rank) {
        return '00:00'
      }
      const diff = moment.duration(moment(this.rank.start_at).add(1, 'hours').diff(this.now))
      return moment.utc(diff.asMilliseconds()).format("mm:ss");
    }
  },
  methods: {
    submit () {
      this.$modal.show('confirm-submit')
    },
    cancel () {
      this.$modal.hide('confirm-submit')
    },
    confirm () {
      this.$http.post('/api/rank/submit').then(res => {
        this.$router.push({name: 'end'})
      })
    }
  },
  watch: {
    now () {
      if (this.rank) {
        const diff = moment(this.rank.start_at).add(1, 'hours').isBefore(this.now)
        if (diff) {
          this.$router.push({name: 'end'})
        }
      }
    }
  },
  components: {
    selection: Selection,
    my_button: MyButton,
  }
}
</script>

<style scoped>
.Contest{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.body{
  width: 60%;
  min-width: 800px;
  position: relative;
}
.title{
  margin-top: 5vw;
  line-height: 3.6vw;
}
.timer {
  position: absolute;
  right: 10px;
  top: 100px;
  font-size: 18px;
  color: red;
}
.title, .toc{
  width: 41.9vw;
  margin-left: auto;
  margin-right: auto;
}
.toc > .prob{
  line-height: 2.6vw;
  color: blue;
  display: list-item;
  margin-left: 1em;
  cursor: pointer;
}

.full{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 3vw;
}
.ppp:last-child>div{
  border-bottom: none;
}
.content {
  font-size: 18px;
  text-align: center;
  margin: 80px 10px;
}
.buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>